import { Action, Reducer } from 'redux';


export interface AppDataState {
    tokens: any;
    app4legalData: any | null;
    meetingData: any;
    matterData: any;
    contractData: any;
    zoom_refresh_token: any;
    zoom_access_token: any;
    check_zoom_auth: Boolean;
    emails: any;
};

//export interface FillUserData {
//    type: 'FILL_USER_DATA',
//    value: any
//};
//export interface SetUserAPIKey {
//    type: 'SET_USER_API_KEY',
//    value: any
//};
//export interface SetBaseUrl {
//    type: 'SET_BASE_URL',
//    value: any
//};

export interface SetAppTokens{
    type: 'UPDATE_Tokens',
    value: any
}
export interface FillRefreshTokenData {
    type: 'FILL_REFRESH_TOKEN_DATA',
    value: any;
};
export interface FillEmails {
    type: 'FILL_Emails_DATA',
    value: any;
};
export interface SetZoomAuth {
    type: 'SET_ZOOM_AUTH',
    value: Boolean;
};
export interface FillAccessTokenData {
    type: 'FILL_ACCESS_TOKEN_DATA',
    value: any;
};
export interface FillApp4legalData {
    type: 'SET_APP4LEGAL_DATA',
    value: any
}
export interface FillMeetingData {
    type: 'SET_MEETING_DATA',
    value: any
};
export interface FillMatterData {
    type: 'SET_MATTER_DATA',
    value: any
};
export interface FillContractData {
    type: 'SET_CONTRACT_DATA',
    value: any
};
export type KnownAction = FillMeetingData | FillMatterData | FillContractData | FillApp4legalData | FillRefreshTokenData | FillAccessTokenData | SetZoomAuth | FillEmails | SetAppTokens ;
 ;

export const actionCreators = {
    fillApp4legalData: (event: any) => ({ type: 'SET_APP4LEGAL_DATA', value: event } as FillApp4legalData),
    fillEmailsData: (event: any) => ({ type: 'FILL_Emails_DATA', value: event } as FillEmails),
    fillZoomMeetingData: (event: any) => ({ type: 'SET_MEETING_DATA', value: event } as FillMeetingData),
    fillMatetrData: (event: any) => ({ type: 'SET_MATTER_DATA', value: event } as FillMatterData),
    fillContractData: (event: any) => ({ type: 'SET_CONTRACT_DATA', value: event } as FillContractData),
    fillRefreshTokenData: (event: any) => ({ type: 'FILL_REFRESH_TOKEN_DATA', value: event } as FillRefreshTokenData),
    fillAccessTokenData: (event: any) => ({ type: 'FILL_ACCESS_TOKEN_DATA', value: event } as FillAccessTokenData),
    setCheckZoomAuth: (event: Boolean) => ({ type: 'SET_ZOOM_AUTH', value: event } as SetZoomAuth),
    fillTokens: (event: any) => ({ type: 'UPDATE_Tokens', value: event } as SetAppTokens),
};

export const reducer: Reducer<AppDataState> = (state: AppDataState | undefined, incomingAction: Action): AppDataState => {
    if (state === undefined) {
        return {
            app4legalData:null,
            meetingData: null,
            matterData: null,
            contractData: null,
            zoom_refresh_token: null,
            zoom_access_token: null,
            check_zoom_auth: false,
            emails: null,
            tokens: null,
        };
    }
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'UPDATE_Tokens':
            return {
                ...state,
                tokens: action.value
            };
        case 'SET_ZOOM_AUTH':
            return {
                ...state,
                check_zoom_auth: action.value
            };
        case 'FILL_Emails_DATA':
            return {
                ...state,
                emails: action.value
            };
        case 'SET_APP4LEGAL_DATA':
            return {
                ...state,
                app4legalData: action.value
            };
        case 'SET_MEETING_DATA':
            return {
                ...state,
                meetingData: action.value
            };
        case 'SET_MATTER_DATA':
            return {
                ...state,
                matterData: action.value
            };
        case 'SET_CONTRACT_DATA':
            return {
                ...state,
                contractData: action.value
            };
        case 'FILL_REFRESH_TOKEN_DATA':
            return {
                ...state,
                zoom_refresh_token: action.value
            };
        case 'FILL_ACCESS_TOKEN_DATA':
            return {
                ...state,
                zoom_access_token: action.value
            };
        default:
            return state;
    }
};
